import { Select } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useGraphic } from "../../../Hooks/useGraphic/useGraphic";
import { NumericFormat } from 'react-number-format';
import PieChart, {
  Series,
  Label,
  Size,
  Legend,
} from "devextreme-react/pie-chart";
import PercentItem from "./PercentItem";
import { ISidebar } from "./ISidebar";

const { Option } = Select;
const QUALITAS_INSTITUTION_ID = 536;

const Sidebar = (props: ISidebar) => {
  const {
    userId,
    userIdInstitution,
    translations,
    placementAgents,
    setSelectedInstitutionId,
    setSelectedVehicleId,
    isCollapsed,
    onToggleCollapse,
    userEmail,
	language
  } = props;
  
  const {
    getContractValues,
    pieData,
    percent,
    tabItems,
    onChangeInstitution,
    selectedInstitution,
    setSelectedInstitution,
    onChangeVehicle,
    selectedVehicle,
  } = useGraphic({
    userIdInstitution,
    placementAgents,
    setSelectedInstitutionId,
    setSelectedVehicleId,
  });

  let blackLogo = '';
  if (userEmail.includes('santander')) {
    blackLogo = 'https://qualitasfunds.blob.core.windows.net/assets/image-gallery/SantanderBlack.png';
  } else if(userEmail.includes('singular')){
    blackLogo = 'https://qualitasfunds.blob.core.windows.net/assets/image-gallery/SingularLogoBlack.png';
  }else{
    blackLogo = 'https://qualitasfunds.blob.core.windows.net/assets/image-gallery/reporting/new_logo_ridgepost_black.png';
  }
  
  return (
    <div className={`overview-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <button className="overview-sidebar-toggle" onClick={onToggleCollapse} type="button">
        {isCollapsed ? <RightOutlined /> : <LeftOutlined />}
      </button>
      {!isCollapsed && (
        <>
      <div className="overview-sidebar-logo">
          <img
          src={blackLogo}
          alt="colocador-logo"
        />
      </div>
      <div className="distributor-select">
        <span>{translations.distribuidor}:</span>
        <Select
          showSearch
          allowClear={userIdInstitution === QUALITAS_INSTITUTION_ID}
          placeholder={userIdInstitution === QUALITAS_INSTITUTION_ID ? translations.allContracts : undefined}
          filterOption={(input, option) =>
            (option!.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          value={selectedInstitution || undefined}
          bordered={false}
          disabled={placementAgents.length === 1}
          onClear={() => onChangeInstitution(0)}
          onChange={(e: number) => onChangeInstitution(e)}
        >
          {placementAgents.map((x: any) => (
            <Option value={x.idInstitution}>{x.institutionLong}</Option>
          ))}
        </Select>
      </div>
      <div className="vehicle-table">
        <div className="vehicle-table-header">
          <span>{translations.vehiculo}</span>
          <span>{translations.maximoDisponible}</span>
        </div>
        <div className="vehicle-table-body">
          {tabItems.map((tx: any, index: number) => (
            <button
              onClick={() => onChangeVehicle(selectedInstitution, index)}
              className={`vehicle-table-body-row ${
                selectedVehicle === index ? "selectedInstitution-pin" : ""
              }`}
            >
              <span>{tx.vehicleShortName}</span>
              <span>
                {
                  <NumericFormat
                    thousandSeparator={language === 'es' ? "." : ","}
                    decimalSeparator={language === 'es' ? "," : "."}
                    value={tx.maxAvailable}
                    displayType={"text"}
                    prefix={"€"}
                  />
                }
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="sidebar-pie">
        {pieData ? (
          <PieChart
            dataSource={pieData}
            palette={['#6B6B6B', '#c9c9c9', '#8fac10']}
          >
            <Series argumentField="type" valueField="value">
              <Label visible={false}/>
            </Series>
            <Legend visible={false}/>
            <Size width={310} height={200} />
          </PieChart>
        ) : null}
      </div>
      <div className="percent-list">
            <PercentItem 
                color="grey-description"
                amount={tabItems[selectedVehicle]?.reserved !== null ? tabItems[selectedVehicle]?.reserved : 0}
                percent={percent?.pre}
                description={translations.totalProceso}
				language={language}
            />
            <PercentItem 
                color="dark-grey-description"
                amount={tabItems[selectedVehicle]?.confirmed !== null ? tabItems[selectedVehicle]?.confirmed : 0}
                percent={percent?.confirmed}
                description={translations.totalFirmado}
				language={language}
            />
            <PercentItem 
                color="green-description"
                amount={tabItems[selectedVehicle]?.available !== null ? tabItems[selectedVehicle]?.available : 0}
                percent={percent?.disp}
                description={translations.totalDisponible}
				language={language}
            />
      </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
